
// ============================================
// PALBOX HOMEPAGE - Done By Elias
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  // ===== MAKE PRODUCT CARDS FULLY CLICKABLE =====
  const productCards = document.querySelectorAll('.featured_products_showcase .multicolumn-card');
  productCards.forEach(card => {
    const link = card.querySelector('a.button');
    if (link) {
      const url = link.getAttribute('href');
      card.style.cursor = 'pointer';
      card.addEventListener('click', function(e) {
        if (!e.target.closest('.button')) {
          window.location.href = url;
        }
      });
    }
  });
  
  // ===== AUTOMATIC TIMELINE PROGRESS CALCULATION =====
  function updateTimelineProgress() {
    const now = new Date();
    const month = now.getMonth(); // 0-11 (0=Jan, 1=Feb, etc.)
    const day = now.getDate();
    
    let progressPercent = 0;
    
    // Q1: Dec 1 - Feb 28 (Winter)
    if (month === 11 || month === 0 || month === 1) {
      // December (month=11), January (month=0), February (month=1)
      let daysIntoQ1;
      
      if (month === 11) {
        // December: day 1-31 of Q1
        daysIntoQ1 = day;
      } else if (month === 0) {
        // January: day 32-62 of Q1
        daysIntoQ1 = 31 + day;
      } else {
        // February: day 63-90 of Q1 (assuming 90 days total)
        daysIntoQ1 = 62 + day;
      }
      
      // Q1 is 25% of the year (0-25%)
      progressPercent = (daysIntoQ1 / 90) * 25;
    }
    // Q2: Mar 1 - May 31 (Spring)
    else if (month >= 2 && month <= 4) {
      let daysIntoQ2;
      if (month === 2) {
        daysIntoQ2 = day;
      } else if (month === 3) {
        daysIntoQ2 = 31 + day;
      } else {
        daysIntoQ2 = 61 + day;
      }
      // Q2 is 25-50%
      progressPercent = 25 + ((daysIntoQ2 / 92) * 25);
    }
    // Q3: Jun 1 - Aug 31 (Summer)
    else if (month >= 5 && month <= 7) {
      let daysIntoQ3;
      if (month === 5) {
        daysIntoQ3 = day;
      } else if (month === 6) {
        daysIntoQ3 = 30 + day;
      } else {
        daysIntoQ3 = 61 + day;
      }
      // Q3 is 50-75%
      progressPercent = 50 + ((daysIntoQ3 / 92) * 25);
    }
    // Q4: Sep 1 - Nov 30 (Fall)
    else {
      let daysIntoQ4;
      if (month === 8) {
        daysIntoQ4 = day;
      } else if (month === 9) {
        daysIntoQ4 = 30 + day;
      } else {
        daysIntoQ4 = 61 + day;
      }
      // Q4 is 75-100%
      progressPercent = 75 + ((daysIntoQ4 / 91) * 25);
    }
    
    // Update the SVG gradient
    const gradientStop2 = document.querySelector('.gradient-stop-2');
    if (gradientStop2) {
      gradientStop2.setAttribute('offset', progressPercent + '%');
      gradientStop2.style.stopColor = '#ebb91e';
      gradientStop2.style.stopOpacity = '1';
    }
    
    // Also update a third stop to create smooth transition
    const gradient = document.getElementById('timelineGradient');
    if (gradient && progressPercent < 100) {
      // Add transition stop if it doesn't exist
      if (!document.querySelector('.gradient-stop-3')) {
        const stop3 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
        stop3.classList.add('gradient-stop-3');
        stop3.setAttribute('offset', (progressPercent + 0.1) + '%');
        stop3.style.stopColor = '#ddd';
        stop3.style.stopOpacity = '1';
        gradient.appendChild(stop3);
      }
    }
    
    // Update active box based on current quarter
    const boxes = document.querySelectorAll('.timeline-box');
    boxes.forEach(box => {
      box.classList.remove('active');
    });
    
    if (month === 11 || month === 0 || month === 1) {
      // Winter
      const winterBox = document.querySelector('.timeline-box[data-season="winter"]');
      if (winterBox) winterBox.classList.add('active');
    } else if (month >= 2 && month <= 4) {
      // Spring
      const springBox = document.querySelector('.timeline-box[data-season="spring"]');
      if (springBox) springBox.classList.add('active');
    } else if (month >= 5 && month <= 7) {
      // Summer
      const summerBox = document.querySelector('.timeline-box[data-season="summer"]');
      if (summerBox) summerBox.classList.add('active');
    } else {
      // Fall
      const fallBox = document.querySelector('.timeline-box[data-season="fall"]');
      if (fallBox) fallBox.classList.add('active');
    }
  }
  
  // Run on page load
  updateTimelineProgress();
});